/* 
 * 21.02.2018
 * NewCatController ile birlikte CategoryAndFilters.js yerine kullanılır
 * Infinity Scroll yerine Paging yapısına uygundur
 * $(document).ready 'nin üstünde bulunan fonksiyonlar açılışta çağrılır
 * $(document).ready 'nin altında bulunan fonksiyonlar event'lara bağlıdır, $(document).ready 'deki click olaylarıyla tetiklenir
 */

var date = new Date();
date.setTime(date.getTime() + (5 * 60 * 1000));
var themePath = "DUB";
var gridCookieName = themePath + "gridCookie";
var mySwiper = [];

function adjustDiscountWidth() {
    $(".LastDiscountContainer").each(function () {
        var $container = $(this);
        var $items = $container.find(".LastDiscount");
        var itemCount = $items.length;

        $items.each(function (index) {
            var isLastSingle = (itemCount % 2 === 1 && index === itemCount - 1);

            if (itemCount === 1 || isLastSingle) {
                $(this).css({ "width": "100%", "margin-right": "0" });
            } else {
                $(this).css({ "width": "calc(50% - 2px)", "margin-right": "4px" });
            }

            if (index % 2 === 1) {
                $(this).css("margin-right", "0");
            }

            if (itemCount <= 2) {
                $(this).css("margin-bottom", "0");
            } else {
                // Son satırda olmayan öğelere margin-bottom ekle
                var isInLastRow = (
                    (itemCount % 2 === 0 && index >= itemCount - 2) ||
                    (itemCount % 2 === 1 && index === itemCount - 1)
                );

                if (isInLastRow) {
                    $(this).css("margin-bottom", "0");
                } else {
                    $(this).css("margin-bottom", "4px");
                }
            }
        });
    });
}

function ToggleLeftBar() {
    $(document).on("click", ".js-filter-toggler", function () {
        if (!isMobileResolution()) {
            $(".js-filter-toggler.is-open").not(this).siblings(".filter-content").slideUp();
            $(".js-filter-toggler.is-open").not(this).removeClass("is-open");
        }

        if ($(this).hasClass("is-open")) {
            $(this).removeClass("is-open");
            $(this).siblings(".filter-content").slideUp();
        }
        else {
            $(this).addClass("is-open");
            $(this).siblings(".filter-content").slideDown();
        }
    });

    if (isMobileResolution()) {
        $(".js-filter-toggler").trigger("click");
    }
}

function SetPriceSlider() {
    var slider = document.getElementById('PriceSlider');

    if (slider != null) {

        var min = $("#MinPrice").val();
        var max = $("#MaxPrice").val();
        var currencySymbol = $("#CurrencySymbol").val();

        noUiSlider.create(slider, {
            start: [min, max],
            connect: true,
            step: 1,
            range: {
                'min': parseInt(min),
                'max': parseInt(max)
            }
        });

        slider.noUiSlider.on('change', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $("#SliderValue").val(Math.round(values[0]) + "-" + Math.round(values[1]));

            if (!isMobileResolution()) {
                //$(".AppylArea .FilterApplyButton").trigger("click");
                GetPageByFilter();
            }
        });

        slider.noUiSlider.on('update', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            //$(".priceView").html("").html(Math.round(values[0]) + " " + currencySymbol + "<span style='padding: 0px 40px;'></span> " + Math.round(values[1]) + " " + currencySymbol);
            $(".priceView .min-price-span").html(Math.round(values[0]) + " " + currencySymbol);
            $(".priceView .max-price-span").html(Math.round(values[1]) + " " + currencySymbol);
        });
    }
}

//function LazyLoad() {
//    $(".ProductList .Prd img.PImage, .ProductList .Prd .js-product-color img").Lazy();
//}

function QueryStringControlForFilter() {

    var vars = [], hash;
    var selectedSize = "";
    var selectedColor = "";
    var selectedCatalog = "";
    var selectedPrice = "";
    var selectedSort = "";
    var selectedGender = "";

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder

    if (NativeQueryFilter.indexOf("=") != "-1") {

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "s") {
                selectedSize = hash[1]; // Size değerleri alınır
            }
            else if (hash[0] == "c") {
                selectedColor = hash[1]; // Color değerleri alınır
            }
            else if (hash[0] == "ct") {
                selectedCatalog = hash[1]; // katalog değerleri alınır
            }
            else if (hash[0] == "prc") {
                selectedPrice = hash[1]; // Price değerini alınır
            }
            else if (hash[0] == "o") {
                selectedSort = hash[1]; // Sıralama seçeneği alınır
            }
            else if (hash[0] == "gn") {
                selectedGender = hash[1]; // Sıralama seçeneği alınır
            }
        }

        if (selectedSize != null && selectedSize != "" && selectedSize != undefined) {
            var selectedSizes = selectedSize.split(',');

            $.each(selectedSizes, function (key, value) {
                $("input[name='s'][value='" + value + "']").prop("checked", true);
            });
        }

        if (selectedColor != null && selectedColor != "" && selectedColor != undefined) {
            var selectedColors = selectedColor.split(',');

            $.each(selectedColors, function (key, value) {
                $("input[name='c'][value='" + value + "']").prop("checked", true);
            });
        }

        if (selectedCatalog != null && selectedCatalog != "" && selectedCatalog != undefined) {
            var selectedCatalogs = selectedCatalog.split(',');

            $.each(selectedCatalogs, function (key, value) {
                $("input[name='ct'][value='" + value + "']").prop("checked", true);
            });
        }

        if (selectedGender != null && selectedGender != "" && selectedGender != undefined) {
            var selectedGenders = selectedGender.split(',');

            $.each(selectedGenders, function (key, value) {
                $("input[name='gn'][value='" + value + "']").prop("checked", true);
            });
        }

        // Seçili Price değer aralığını ayarlar
        if (selectedPrice != null && selectedPrice != "" && selectedPrice != undefined) {
            $("#SliderValue").val(selectedPrice);
            var SelectedPrices = selectedPrice.split('-');

            var slider = document.getElementById('PriceSlider');

            if (slider != null)
                slider.noUiSlider.set([SelectedPrices[0], SelectedPrices[1]]);
        }
        // Seçili Price değer aralığını ayarlar

        if (selectedSort != null && selectedSort != "" && selectedSort != undefined) {
            $("input[name='o'][value='" + selectedSort + "']").prop("checked", true);
        }
    }
}

function BackButtonLastScroll() {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var browserName = navigator.userAgent;
    if (browserName.indexOf("Chrome")) {
        browserName = "Chrome";
    }

    var pgType = $("#PgType").val();
    var lastScrollTop = $.cookie("lastScroll");
    var CatID = $("#PID").val();
    var lastScrollTopFirst = $.cookie("getLastScrollFirst");

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

    if (pgType == "Cat") {

        if (CatID != $.cookie("lastCatalogID")) {
            lastScrollTopFirst = 0;
            $.cookie("lastCatalogID", CatID, { path: '/', expires: date });
        }

        if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
            if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {

                var listHeight = $(".ProductList").height();
                lastScrollTop = lastScrollTop - (listHeight /** (currentPage - 1)*/);

                if (lastScrollTop > 0) {
                    $('html, body').animate({
                        scrollTop: lastScrollTop
                    }, 0);
                }
            }
        }

        //if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
        //    if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTop
        //            }, 0);
        //        }, 1000);
        //    }
        //}
        //else {

        //    if (lastScrollTopFirst != null && lastScrollTopFirst != "" && lastScrollTopFirst != undefined && lastScrollTopFirst > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTopFirst
        //            }, 0);
        //        }, 1000);
        //    }
        //}

        $.cookie("getLastScrollFirst", "0", { path: '/', expires: date });
        $.cookie("lastScroll", "0", { path: '/', expires: date });
    }
}

function getPenPath() {
    var vars = [], hash;
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder
    var currentPage = 1;

    if (NativeQueryFilter.indexOf("=") != "-1") {
        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                currentPage = hash[1];
            }
        }
    }

    var params = GenerateParams("paging", (parseInt(currentPage) + 1) /*this.loadCount + 2*/); // Sayfalama için istek parametresi üretir
    if (params) {
        //return "/" + $("#SmallLangCode").val() + "/p/Home/GetProductList?" + params;
        return "?" + params;
    }
}

function InfinityScroll() {
    var $container = $('.ProductList').infiniteScroll({
        path: getPenPath,
        append: '.Prd',
        scrollThreshold: 500,
        checkLastPage: ".pageEnd"
    });
    var infScroll = $container.data('infiniteScroll');

    $container.on('load.infiniteScroll', function () {
        requestAnimationFrame(adjustDiscountWidth);
        $(window).resize(adjustDiscountWidth);
        setTimeout(function () {
            //LazyLoad();
            if (mySwiper.length > 0) {
                mySwiper.forEach(function (item, index) {
                    item.update();
                    item.destroy(true, false);
                    //mySwiper.splice(index);
                });
            }

            GenerateSwiper('.product-swipe');
        }, 2000);
    });
}

function IsFollowCategory() {
    if ($(".ProductList .Prd .js-add-favorites").length <= 0) {
        return;
    }

    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/ProductDetails/IsFollowAll",
        dataType: 'json',
        async: true,
        success: function (dt) {
            updateList(dt);
        }
    });

    var updateList = function (dt) {
        $(".ProductList .Prd .QuickLookLikeBtn").removeClass("active");

        for (var i in dt) {
            var item = dt[i];

            var followlar = $(".ProductList .Prd .QuickLookLikeBtn").filter(function (index) {
                return $(this).attr("data-id") == item["ProductID"] && $(this).attr("data-colorid") == item["ColorID"];
            });

            if (followlar.length > 0) {
                var followItem = $(followlar[0]);
                followItem.addClass("active");
                followItem.find(".sorsfont").removeClass("sorsfont-favorite").addClass("sorsfont-favorite-o");

                //if (followItem.hasClass("active")) {
                //    followItem.children("img").attr("src", "/Images/OXNW/like_full.svg");
                //}
            }
        }
    };
}

function FollowProperty() {
    $(document).on("click", ".QuickLookLikeBtn:not(.active)", function () {
        var ProductID = $($(this)).attr("data-id");
        var ColorID = $($(this)).attr("data-colorid");
        button = $(this);
        GenerateLocalLoading(button.closest(".Prd"), "show");

        AddToFavorite(ColorID, ProductID, function (result, msg) {
            if (result == true) {
                button.addClass("active");
                button.find(".sorsfont").removeClass("sorsfont-favorite").addClass("sorsfont-favorite-o");
            }
            else {
                //SwalGenerate("error", msg, getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));

                var loginLink = getRequestRoute() + "/p/User/Login";

                SwalGenerate("warning", msg, getStandartMessages("IslemBasarisiz"), "<a href='" + loginLink + "'>" + getStandartMessages("GirisYap") + "</a>");
            }

            GenerateLocalLoading(button.closest(".Prd"), "hide");
        });
    });

    $(document).on("click", ".QuickLookLikeBtn.active", function () {
        var ProductID = $($(this)).attr("data-id");
        button = $(this);
        GenerateLocalLoading(button.closest(".Prd"), "show");

        removeFavorite(ProductID, function (result) {
            if (result == true) {
                button.removeClass("active");
                button.find(".sorsfont").removeClass("sorsfont-favorite-o").addClass("sorsfont-favorite");
            }
            else {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            }

            GenerateLocalLoading(button.closest(".Prd"), "hide");
        });
    });
}

function GenerateSwiper(element) {

    if (mySwiper.length > 0) {
        mySwiper.forEach(function (item, index) {
            mySwiper.splice(index);
        });
    }

    var i = 0;

    $(element).each(function (index) {
        $(this).attr("data-swiper", i);
        i++;

        mySwiper.push(
            new window.Swiper6($(this)[0], {
                loop: true,
                preloadImages: false,
                lazy: true,
                slidesPerView: "auto",
                centeredSlides: true,
                autoResize: true,
                //allowTouchMove: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: "bullets",
                    clickable: false
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            })
        );

        $(this).find('.swiper-button-prev').html('<i class="fa fa-chevron-left"></i>');
        $(this).find('.swiper-button-next').html('<i class="fa fa-chevron-right"></i>');
    });
}


$(document).ready(function () {
    var PageType = $("#PgType").val();

    if (PageType == "Cat" || PageType == "Combine") {

        var InfinityScroll = $("#IsInfinity").val();

        if (InfinityScroll == "True") {
            $container = $('.ProductList').infiniteScroll({
                path: getPenPath,
                append: '.Prd',
                scrollThreshold: 500,
                checkLastPage: ".pageEnd"
            });
            var infScroll = $container.data('infiniteScroll');

            $container.on('load.infiniteScroll', function () {
                requestAnimationFrame(adjustDiscountWidth);
                $(window).resize(adjustDiscountWidth);
                setTimeout(function () {
                    //LazyLoad();

                    if (mySwiper.length > 0) {
                        mySwiper.forEach(function (item, index) {
                            item.update();
                            item.destroy(true, false);
                            //mySwiper.splice(index);
                        });
                    }

                    GenerateSwiper('.product-swipe');
                }, 1000);
            });
        }

        adjustDiscountWidth();
        $(window).resize(adjustDiscountWidth);

        BackButtonLastScroll();
        ToggleLeftBar();
        SetPriceSlider();
        //LazyLoad();
        QueryStringControlForFilter(); // QueryString'deki filtreleri kontrol eder
        BrowserBackAndPrevButtonControl(); // Browser iler/geri tuşları tetiklenince çalışır
        IsFollowCategory();
        FollowProperty();

        if (mySwiper.length > 0) {
            mySwiper.forEach(function (item, index) {
                item.update();
                item.destroy(true, false);
                //mySwiper.splice(index);
            });
        }

        GenerateSwiper('.product-swipe');


        if ($('.js-catalog-description').length > 0) {
            var callapseHeight = 58;
            if (isMobileResolution())
                callapseHeight = 36;

            $('.js-catalog-description').readmore({
                speed: 75,
                collapsedHeight: callapseHeight,
                heightMargin: 0,
                moreLink: '<a href="#" role="button" class="read-more-text">Devamını Oku</a>',
                lessLink: '<a href="#" role="button" class="read-less-text">Daha Az Göster</a>'
            });
        }

        if (isMobileResolution()) {
            $(document).on("click", ".js-open-filter-flyout", function () {
                if ($("body").hasClass("show-filter"))
                    MobileFilterOperation("hide");
                else
                    MobileFilterOperation("show");
            });

            $(document).on("click", ".js-mobile-filter", function () {
                GetPageByFilter();
            });

            $(document).on("click", ".js-clear-mobile-filter", function () {
                $(".FilterForm input[type='checkbox']").prop("checked", false);
                $(".FilterForm input[type='radio']").prop("checked", false);
                $(".FilterForm input[type='radio'][name='o'][value='3']").prop("checked", true);
                var slider = document.getElementById('PriceSlider');
                slider.noUiSlider.reset()

                GetPageByFilter();
            });
        }
        else {
            $(document).on("change", "input[name='ct'], input[name='s'], input[name='c'], input[name='o'], input[name='gn']", function () {
                GetPageByFilter();
            });
        }

        if ($(".ProductList.NotFoundContainer .NotFound").length > 0) {
            var LastVisitedPrds = GetLastVisitedData();

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
                GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
                    if (dt != "") {
                        $(".ProductList.NotFoundContainer .SuggestedProductsContainer .AutoGetLastVisited").append(dt);
                        SlickSlider("suggested");
                    }
                });
            }
        }
    }
    else if (PageType == "Search") {
        //LazyLoad();
        IsFollowCategory();
        FollowProperty();

        if (mySwiper.length > 0) {
            mySwiper.forEach(function (item, index) {
                item.update();
                item.destroy(true, false);
                //mySwiper.splice(index);
            });
        }

        GenerateSwiper('.product-swipe');


        adjustDiscountWidth();
        $(window).resize(adjustDiscountWidth);

    }
    else if ($("#Home").length > 0)//home ise
    {
        adjustDiscountWidth();
        $(window).resize(adjustDiscountWidth);
    }

    // Ürüne renklerine ait fotoğrafları getirir
    //GetImageOfColors(params, item_unique_id, $currentColor);

    $(document).on("click", ".c-products-list .product-tile a", function () {
        var ScrollContentID = "LastScrollTop" + $("#PID").val();
        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });
    })

    // Paging İsteği
    $(".Pages a, #nextPage a").live("click", function () {
        var pageNo = $(this).attr("data-pgno");

        $.cookie("lastScroll", 0, { path: '/', expires: date });
        $.cookie("getLastScrollFirst", 0, { path: '/', expires: date });

        if (pageNo != null && pageNo != undefined && pageNo != "") {
            getPageByPageNo(pageNo, "false");
        }
    });

    // Kategori Açıklama Yazısını Gösterir
    $('.CatShowMore, .CatShowLess').on('click', function (e, index) {
        var Clicked = $(this).attr("class");
        CatDescShowOrHide(Clicked);
    });
});


// Kategori Açıklama Yazısını Açıp/Kapatır
function CatDescShowOrHide($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "CatShowMore") {
            $(".CatShowMore").hide();
            $('.CatShowLess').show();
            $('.CatSecondPart').show();
            $('.CatShortPart').hide();
        }
        else {
            $(".CatShowLess").hide();
            $('.CatShowMore').show();
            $('.CatSecondPart').hide();
            $('.CatShortPart').show();
        }
    }
}

// Paging İçin Ajax
function getPageByPageNo($pageNo, $IsBack) {
    if ($pageNo != null && $pageNo != "" && $pageNo != undefined && $pageNo != "0") {

        if ($IsBack != null && $IsBack != "" && $IsBack != undefined && $IsBack == "false") {
            GenerateUrlHistoy(); // URL History oluşturur
        }

        backdropControl("show");

        var newScrollPosition = $(".Products").position(); // Filtreleme&Sayfalama işleminden sonra scroll'un gideceği position değeri
        if ($IsBack == "false") {
            $('html, body').animate({ // Listenin başına döndürür
                scrollTop: 0 //newScrollPosition.top
            }, 0);
        }

        var params = GenerateParams("paging", $pageNo); // Sayfalama için istek parametresi üretir

        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/Home/GetProductList",
            data: params,
            cache: false,
            success: function (data) {

                backdropControl("hide");

                SetUrl(params);

                if ($(".ProductList .NotFound").length <= 0) {
                    var IsInfinity = $("#IsInfinity").val();

                    if (IsInfinity == "True") {
                        $container.infiniteScroll('destroy');
                        $(".Products").html(data);
                        InfinityScroll();
                        //LazyLoad();
                    }
                    else {
                        $(".Products").html(data);
                        //LazyLoad();
                    }

                    adjustDiscountWidth();
                    $(window).resize(adjustDiscountWidth);

                    IsFollowCategory();
                }

                //#region InsiderObject
                var InsiderObjectBegin = data.indexOf("<!--InsiderObject-") + "<!--InsiderObject-".length;
                var InsiderObjectEnd = data.indexOf("-InsiderObject-->") - "-InsiderObject-->".length;

                var InsiderObjectCode = data.substr(InsiderObjectBegin, InsiderObjectEnd).replace("-InsiderObject-->", "").replace("<!--InsiderObject-", "");

                if (InsiderObjectCode != undefined && InsiderObjectCode.length > 0) {
                    window.insider_object = JSON.parse(InsiderObjectCode);
                }

                data = data.replace(InsiderObjectCode, "").replace("-InsiderObject-->", "").replace("<!--InsiderObject-", "");
                //#endregion InsiderObject
                ProductClickForDataLayer();

            },
            error: function () {
                backdropControl("hide");
            }
        });

    }
}

// Filter İçin Ajax
function GetPageByFilter() {
    var newScrollPosition = $(".Products").position(); // Filtreleme&Sayfalama işleminden sonra scroll'un gideceği position değeri

    $('html, body').animate({
        scrollTop: $(".plp-refine-bar").offset().top - 100
    }, 0);

    var params = GenerateParams("filter"); // Filtreleme için istek parametresi üretir

    var loadingArea = $("body");

    GenerateLocalLoading(loadingArea, "show");

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/Home/GetProductList",
        data: params,
        cache: false,
        success: function (data) {
            //#region InsiderObject
            //var InsiderObjectBegin = data.indexOf("<!--InsiderObject-") + "<!--InsiderObject-".length;
            //var InsiderObjectEnd = data.indexOf("-InsiderObject-->") - "-InsiderObject-->".length;
            //
            //var InsiderObjectCode = data.substr(InsiderObjectBegin, InsiderObjectEnd).replace("-InsiderObject-->", "").replace("<!--InsiderObject-", /"");
            //
            //if (InsiderObjectCode != undefined && InsiderObjectCode.length > 0) {
            //    window.insider_object = JSON.parse(InsiderObjectCode);
            //}
            //
            //data = data.replace(InsiderObjectCode, "").replace("-InsiderObject-->", "").replace("<!--InsiderObject-", "");
            //#endregion InsiderObject

            SetUrl(params);

            var IsInfinity = $("#IsInfinity").val();

            if (IsInfinity == "True") {
                $container.infiniteScroll('destroy');
                $(".Products").html(data);
                InfinityScroll();
            }
            else {
                $(".Products").html(data);
            }

            if (mySwiper.length > 0) {
                mySwiper.forEach(function (item, index) {
                    item.update();
                    item.destroy(true, false);
                    //mySwiper.splice(index);
                });
            }

            GenerateSwiper('.product-swipe');


            adjustDiscountWidth();
            $(window).resize(adjustDiscountWidth);

            //LazyLoad();
            IsFollowCategory();

            if (isMobileResolution())
                MobileFilterOperation("hide");

            GenerateLocalLoading(loadingArea, "hide");
        },
        error: function () {
            GenerateLocalLoading(loadingArea, "hide");
        }
    });
}

// Filtreleme Ve Sayfalama İsteklerinde Parametre Oluşturur
function GenerateParams($action, $pageNo) {
    var params = "";

    if ($action != null && $action != "" && $action != undefined) {

        // Sayfa Numarasını Ayarlar
        if ($action == "paging") {
            params = "p=" + $pageNo;
        }
        else if ($action == "filter") {
            params = "p=1";
        }
        // Sayfa Numarasını Ayarlar

        var CatalogPart = "&ct=" + $("#PID").val(); // Catalog ID'sini alır        

        if ($("input[name='ct']:checked").length > 0) {
            CatalogPart = "&ct=";

            $("input[name='ct']:checked").each(function () {
                CatalogPart += $(this).val() + ",";
            });

            CatalogPart = CatalogPart.substring(0, CatalogPart.length - 1);
        }

        params += CatalogPart;

        // Sıralama Seçeneğini Kontrol Eder
        //$PrcSort = $("#PrdSort > li > label.checked");
        //var SelectedSortID = $PrcSort.parent().children("input").val();
        //if (SelectedSortID != null && SelectedSortID != "" && SelectedSortID != undefined) {
        //    params += "&o=" + SelectedSortID;
        //}

        if ($("input[name='o']:checked").length > 0) {
            params += "&o=" + $("input[name='o']:checked").val()
        }
        // Sıralama Seçeneğini Kontrol Eder

        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler
        //var SelectedColors = "";
        //$("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür
        //    SelectedColors += $(this).children("input").val() + ",";
        //});

        //if (SelectedColors != "" && SelectedColors != null && SelectedColors != undefined) {
        //    params += "&c=" + SelectedColors.substring(0, SelectedColors.length - 1); // Substring ile sondaki virgül silinir
        //}

        if ($("input[name='c']:checked").length > 0) {
            var SelectedColors = "&c=";

            $("input[name='c']:checked").each(function () {
                SelectedColors += $(this).val() + ",";
            });

            SelectedColors = SelectedColors.substring(0, SelectedColors.length - 1);
            params += SelectedColors;
        }
        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler
        //var SelectedSizes = "";
        //$("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür
        //    SelectedSizes += $(this).children("input").val() + ",";
        //});

        //if (SelectedSizes != "" && SelectedSizes != null && SelectedSizes != undefined) {
        //    params += "&s=" + SelectedSizes.substring(0, SelectedSizes.length - 1); // Substring ile sondaki virgül silinir
        //}

        if ($("input[name='s']:checked").length > 0) {
            var SelectedSizes = "&s=";

            $("input[name='s']:checked").each(function () {
                SelectedSizes += $(this).val() + ",";
            });

            SelectedSizes = SelectedSizes.substring(0, SelectedSizes.length - 1);
            params += SelectedSizes;
        }
        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler

        if ($("input[name='gn']:checked").length > 0) {
            var SelectedGender = "&gn=";

            $("input[name='gn']:checked").each(function () {
                SelectedGender += $(this).val() + ",";
            });

            SelectedGender = SelectedGender.substring(0, SelectedGender.length - 1);
            params += SelectedGender;
        }

        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
        if ($("#SliderValue").val() != null && $("#SliderValue").val() != "" && $("#SliderValue").val() != undefined && $("#SliderValue").val() != "0-500") {
            params += "&prc=" + $("#SliderValue").val();
        }
        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
    }

    return params;
}

function SetUrl(params) {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var newURL = location.pathname + "?" + params;

    if (ios == false) {
        window.history.replaceState({}, "", newURL); // Sayfa URL'inin değişmesini sağlar
    }
    else {
        history.pushState({}, "", newURL);
    }
}

function GenerateUrlHistoy() {

    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // Var olan QueryString'i okur
    var PathName = window.location.pathname; // Bulunan kataloğun url'ini alır
    var CurrentURL = "";

    if (getQueryFilter.indexOf("=") != "-1") {
        CurrentURL = PathName + "?" + getQueryFilter;
    }
    else {
        CurrentURL = PathName;
    }

    if (CurrentURL != null && CurrentURL != "" && CurrentURL != undefined) {
        window.history.pushState('', '', CurrentURL);
    }
}

function MobileFilterOperation(event) {
    if (!isMobileResolution())
        return;

    if (event === "show") {
        $("body").addClass("show-filter");
        $('html, body').animate({
            scrollTop: $(".js-other-filters-wrapper").offset().top - 100
        }, 500);
        $(".js-filters-wrap").css("height", "calc(var(--window-height, 100vh) - 160px)");
    }
    else {
        $("body").removeClass("show-filter");
        $(".js-filters-wrap").css("height", "0");
    }

    backdropControl(event);
}

// Sayfalar Arası Gezerken Browser Back/Prev Butonlarını Kontrol Eder
function BrowserBackAndPrevButtonControl() {
    $(window).on('popstate', function (event) {

        var vars = [], hash;
        var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        var IsCatalogFirsPage = true;

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                getPageByPageNo(hash[1], "true");
                IsCatalogFirsPage = false;
            }
        }

        if (IsCatalogFirsPage == true) {
            getPageByPageNo(1, "true");
        }

    });
}

// Dataleyer
function ProductClickForDataLayer() {
    $(".Products .ProductList .urunlist  a").click(function () {

        event.preventDefault();

        var redirectUrl = $(this).attr("href");
        var ProductID = $(this).attr("data-product");
        var ColorID = $(this).attr("data-color");
        var LangID = $("#LangID").val();
        var SmallLangCode = $("#SmallLangCode").val();

        var CurrentCatalogID = $("#PID").val();

        if (CurrentCatalogID == null || CurrentCatalogID == "" || CurrentCatalogID == undefined) {
            CurrentCatalogID = $("#PgCatalogs").val();
        }

        if (ProductID == null || ProductID == "" || ProductID == undefined || ColorID == null || ColorID == "" || ColorID == undefined) {
            document.location = redirectUrl;
        }
        else {

            var params = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&LangID=" + LangID + "&SmallLangCode=" + SmallLangCode + "&CurrentCatalogID=" + CurrentCatalogID;

            $AjaxLoader = $(".PrdContainer .AjaxLoaderDiv");
            $AjaxLoader.addClass("AjaxLoaderPleaseWait");

            var SelectedProductID = $(this).attr("data-product") + "-" + $(this).attr("data-color");

            var i = 0;
            $(".PrdContainer .Products .urunlist").each(function () {
                i++;

                var CurrentProductID = $(this).find("a").attr("data-product") + "-" + $(this).find("a").attr("data-color");

                if (SelectedProductID == CurrentProductID) {
                    return false;
                }
            });

            if (i > 0) {
                params += "&Position=" + i;
            }

            $.ajax({
                type: "GET",
                url: getRequestRoute() + "/p/Cat/GetProductDataLayerData",
                data: params,
                cache: false,
                success: function (data) {
                    if (data == null || data == "" || data == undefined) {
                        document.location = redirectUrl;
                    }
                    else {
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({
                            "event": "eec.impressionClick",
                            "ecommerce": {
                                "click": {
                                    "actionField": {
                                        "list": "Related products"
                                    },
                                    "products": [JSON.parse(data)]
                                }
                            }
                        });

                        document.location = redirectUrl;
                    }
                },
                error: function (data) {
                    document.location = redirectUrl;
                }
            });
        }

        // return false;
    });
}